import {
    FilledTextFieldProps,
    OutlinedTextFieldProps,
    StandardTextFieldProps,
    TextFieldVariants,
} from '@mui/material/TextField';
import { PickerValidDate } from '@mui/x-date-pickers';
import { DateTimePickerProps, DateTimePicker as MuiDateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

export type SharedDateTimePickerProps<TEnableAccessibleFieldDOMStructure extends boolean = false> = DateTimePickerProps<
    PickerValidDate,
    TEnableAccessibleFieldDOMStructure
> &
    React.RefAttributes<HTMLDivElement> & {
        TextFieldProps?: {
            variant?: TextFieldVariants | undefined;
        } & Omit<FilledTextFieldProps | OutlinedTextFieldProps | StandardTextFieldProps, 'variant'>;
    };
export const DateTimePicker = <TEnableAccessibleFieldDOMStructure extends boolean = false>({
    TextFieldProps,
    ...props
}: SharedDateTimePickerProps<TEnableAccessibleFieldDOMStructure>) => {
    return (
        <MuiDateTimePicker
            ampm={false}
            slotProps={{
                textField: {
                    focused: true,
                    ...TextFieldProps,
                },
            }}
            {...props}
        />
    );
};
